import { supabase } from './supabase';
import logger from '../utils/logger';

export const createCheckoutSession = async (
  items,
  successUrl,
  cancelUrl,
  shippingAddress,
  deliveryFee,
  creditApplied = 0
) => {
  try {
    const { data, error } = await supabase.functions.invoke('create-checkout-session', {
      body: {
        items,
        success_url: successUrl,
        cancel_url: cancelUrl,
        shipping_address: shippingAddress || null,
        delivery_fee_cents: Math.round((Number(deliveryFee) || 0) * 100),
        credit_applied_cents: Math.round((Number(creditApplied) || 0) * 100),
      },
    });

    if (error) {
      const details =
        (error.context && (error.context.error || error.context.message)) ||
        (typeof error.context === 'string' ? error.context : null);
      const status = error.status || error.code || '';
      throw new Error(
        details
          ? `Checkout failed${status ? ` (${status})` : ''}: ${details}`
          : error.message || 'Failed to create checkout session'
      );
    }

    return data;
  } catch (error) {
    logger.error('Error creating checkout session:', error);
    throw error;
  }
};

// 31:47:src/services/stripeService.js
export const getOrderStatus = async (sessionId) => {
  try {
    const { data, error } = await supabase.functions.invoke('get-order-status', {
      body: { session_id: sessionId },
    });

    if (error) {
      const status = error.status || error.code || '';
      const details =
        (error.context && (error.context.error || error.context.message)) ||
        (typeof error.context === 'string' ? error.context : null);
      throw new Error(
        details
          ? `Edge Function error${status ? ` (${status})` : ''}: ${details}`
          : error.message || 'Failed to get order status'
      );
    }

    return data;
  } catch (error) {
    logger.error('Error getting order status:', error);
    throw error;
  }
};
